module.exports = __webpack_public_path__ + "img/onerror-store.0dfe981.jpg";